<div class="grid-container" [formGroup]="form">
    <ui-form-field class="grid-span-2" [label]="'PAGES.ALERT_SCENARIO_EDITION.THRESHOLD_FORM.SCENARIO_NAME' | translate">
        <input
            advizeoInput
            formControlName="name"
            [required]="true"
            [placeholder]="'PAGES.ALERT_SCENARIO_EDITION.THRESHOLD_FORM.SCENARIO_NAME_PLACEHOLDER' | translate"
        />
        <ui-form-error>{{ 'ERRORS.FORM.REQUIRED' | translate }}</ui-form-error>
    </ui-form-field>

    <ui-form-field class="grid-span-2" [label]="'PAGES.ALERT_SCENARIO_EDITION.THRESHOLD_FORM.MEASURE_TYPE' | translate">
        <ui-select formControlName="measureType" [options]="measureTypes" [hideSearch]="true" [required]="true">
            <ng-template let-option="option">{{ 'MEASURE_TYPE.' + option | translate }}</ng-template>
        </ui-select>
        <ui-form-error>{{ 'ERRORS.FORM.REQUIRED' | translate }}</ui-form-error>
    </ui-form-field>

    <ui-form-field class="grid-span-2" [label]="'PAGES.ALERT_SCENARIO_EDITION.THRESHOLD_FORM.UNIT' | translate">
        <ui-select
            formControlName="unit"
            [options]="units$ | async"
            [hideSearch]="true"
            [required]="true"
            [disabled]="!form.value.measureType"
        >
            <ng-template let-option="option">{{ (option | referenceList: 'unit')?.label }}</ng-template>
        </ui-select>
        <ui-form-error>{{ 'ERRORS.FORM.REQUIRED' | translate }}</ui-form-error>
    </ui-form-field>
</div>
